class TabGroup {
  constructor(name) {
    this.name = name || 'defaultTabGroup';
    this.tabs = [];
  }
}

export { TabGroup };
